import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vant/lib/index.css'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import enLang from './lang/en'
import zhTWLang from './lang/zh-tw'
import Vant from 'vant';
import '@/styles/index.scss' // global css
// 额外提供了一系列类名，用于在某些条件下隐藏元素
import 'element-ui/lib/theme-chalk/display.css';
import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import '@babel/polyfill'
import Print from 'vue-print-nb'



Vue.use(Vant);
Vue.use(Print);
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }
// 设置请求头
// Vue.http.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
function onInput(el, ele, binding, vnode) {
  function handle() {
    let val = ele.value
    // modifiers为修饰符对象，传入了float，则其float属性为true
    if (binding.modifiers.float) {
    // 清除"数字"和"."以及"-"以外的字符
    val = val.replace(/[^\-\d.]/g, '')
    // 只保留第一个'-'号
    val = val.replace(/\.{2,}/g, '.').replace(/\-{2,}/g, '-')
    // 将 '-.' 替换成 '-0.'
    val = val.replace(/^\./g, '0.').replace(/^\-\./, '-0.')
    if (typeof binding.value !== 'undefined') {  //值為填
      // 期望保留的最大小数位数
      let pointKeep = 0
      if (typeof binding.value === 'string' || typeof binding.value === 'number') {
        pointKeep = parseInt(binding.value)
      } else if (typeof binding.value === 'object') {
        // 支持新的小数点保留位配置
        pointKeep = binding.value.decimal
      }
      if (!isNaN(pointKeep)) {
        if (!Number.isInteger(pointKeep) || pointKeep < 0) {
          pointKeep = 0
        }
        // 增加'-'号的支持
        const str='^(\\-)*(\\d+)\\.(\\d\{' + pointKeep + '}).*$'
        const reg=new RegExp(str)
        if (pointKeep === 0) {
          // 不需要小数点
          val = val.replace(reg, '$1$2')
        } else {
          // 通过正则保留小数点后指定的位数
          val = val.replace(reg, '$1$2.$3')
        }
      }
    } else {
      val = ele.value.replace(/[^\d]/g, '')
    }
    if (val !== '' && typeof binding.value === 'object') {
      let { min, max } = binding.value
      min = parseFloat(min)
      max = parseFloat(max)
      if (!isNaN(min)) {
        if (min >= 0) {
          // 不能是负数
          val = val.replace('-', '')
        }
        if (parseFloat(val) < min) {
          val = min
        }
      }
      if (!isNaN(max)) {
        if (parseFloat(val) > max) {
        val = max
        }
      }
    }
    ele.value = val
   }
  }
  return handle

}
const numberInput= {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
  },
}
Vue.directive('number-input', numberInput)

Vue.use(VueI18n)
const messages = {
  en: enLang,
  zh_tw:zhTWLang
}

if(!localStorage.getItem('locale')){
	localStorage.setItem('locale','zh_tw');
}



let i18n = new VueI18n({
  locale: localStorage.getItem('locale'), // set locale
  messages, // set locale messages
})

let locale;
if( localStorage.getItem('locale') === 'en' ){
  locale = enLocale;
} else if( localStorage.getItem('locale') === 'zh_tw' ){
  locale = zhTWLocale;
}
// set ElementUI lang to EN
Vue.use(ElementUI,{
  locale
})
Vue.directive("btn-control", {
  // 插入dom 时做的事情
  inserted: function(el, bind) {
      el.addEventListener("click", () => {
          el.disabled = true;
          bind.value().then(res => {
              el.disabled = false;
          });
      });
  }
});
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'watchStorage') {

      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);

              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}
// console.log(process.env.VUE_APP_URL,'什么环境')
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
// new Vue({ i18n }).$mount('#app')
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
